/*
 * Copyright (c) 2022 SARL SIGMA POLYNESIA
 */

import { getCustomerName } from '../../lib/customer.mjs'
import CustomerInfoHoverCard from './CustomerInfoHoverCard'
import { getCustomerLink } from '../../lib/links/customerLinks'
import AnchorLink from '../../../../client/js/components/AnchorLink'

export type CustomerNameProps = {
  customer: Partial<Customer>
}

function CustomerLink (props: CustomerNameProps) {
  const { customer } = props
  return (
    <CustomerInfoHoverCard customerId={customer?.id}>
      <span>
        <AnchorLink to={getCustomerLink(customer.id)}>
          {getCustomerName(customer)}
        </AnchorLink>
      </span>
    </CustomerInfoHoverCard>
  )
}

export default CustomerLink
